document.addEventListener("DOMContentLoaded", function(event) {

  var mobileNav = document.querySelector(".faq-select");
	mobileNav.onchange = function(e) {
		e.preventDefault();
		var selectedOption = this.value;
		//window.location.href = selectedOption;
		$('html, body').stop().animate({
			scrollTop: $(selectedOption).offset().top - 100
		}, 1000);
	}

	/* Side Nav Smooth Scroll */
	var faqNav = document.querySelectorAll('.faq-nav li a');
	faqNav.forEach(function(item) {
		item.addEventListener("click", function(e) {
			e.preventDefault();
			var href = item.getAttribute("href");
			if(href.length) {
				const element = document.querySelector(`${href}`);
				var target = $(href);
				$('html, body').stop().animate({
					scrollTop: target.offset().top - 150
				}, 1000);
			}
		});
	});
});